import { render } from "./GetCoupons.vue?vue&type=template&id=2155a5da"
import script from "./GetCoupons.vue?vue&type=script&lang=js"
export * from "./GetCoupons.vue?vue&type=script&lang=js"

import "./GetCoupons.vue?vue&type=style&index=0&id=2155a5da&lang=scss"

import exportComponent from "F:\\my_work_space\\cmall-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__